import React from 'react';
import {
  Dialog,
  DialogContent,
  Stack,
  IconButton,
  Chip,
  Box,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import { getSubmissionState } from '../../../../store/SubmissionSlice';
import { IQuestion } from '../../../../store/QuestionSlice';
import { useAppSelector } from '../../../../hooks';
import { SafeAreaGaps } from '../../../../helper';
import BasicLoader from '../../../../components/Loaders/BasicLoader';

export interface IShowAnswerModal {
  open: boolean;
  onClose: () => void;
  question: IQuestion;
}

const labelStyles: React.CSSProperties = {
  borderRadius: '4px',
  fontWeight: 600,
  marginRight: '5px',
};

const ShowAnswerModal: React.FC<IShowAnswerModal> = ({
  open,
  onClose,
  question,
}) => {
  // HOOKS
  const submissionState = useAppSelector(getSubmissionState);

  // RENDER
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { m: '15px', minWidth: { xs: '90vw', sm: '400px' } } }}
    >
      <DialogContent>
        {submissionState.status === 'loading' ? (
          <Box component="div" role="presentation">
            <BasicLoader />
          </Box>
        ) : (
          <Box component="div" role="presentation">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                position: 'sticky',
                top: `calc(${SafeAreaGaps.top} - 20px)`,
                backgroundColor: 'background.paper',
              }}
            >
              <Chip label="Marking Scheme" style={labelStyles} />
              <IconButton onClick={onClose}>
                <CancelIcon />
              </IconButton>
            </Stack>
            {question && question.markingSchema ? (
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: question.markingSchema || '',
                }}
              />
            ) : null}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ShowAnswerModal;
